// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 160px;
    text-align: center;
    border-radius: 240px 250px 0px 0px;
    background: #FFF;
}

.ant-layout-footer {
    padding: 0px !important;
    background: none !important;
}

.footer-banner {
    padding-top: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.footer-grid-container {
    display: grid;
    /* grid-template-columns: repeat(6, 1fr); */
    grid-template-columns: repeat(7, 1fr);
    /* gap: 42px; */
    gap: 16px;
    padding-top: 200px;
}

.footer-item-title {
    letter-spacing: 0.42px;
}

.footer-item-list {
    text-align: left;
}

.footer-submenu-list {
    list-style: none;
    padding: 0px;
    margin-bottom: 12px;
}

.footer-item-submenu {
    padding: 10px 0;
    letter-spacing: 0.42px;
}

.mobile-footer-content {
    width: 100%;
    padding: 70px 0;
}

.mobile-footer-item-list {
    text-align: left;
}

.footer-end {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 56px 0;
    border-top: 1px solid #BFBFBF;
    padding-top: 42px;
}

.footer-banner .button-row {
    min-width: 270px;
    width: fit-content;
}

.footer-banner .button-row .button-yellow-md {
    height: 160px;
    width: 100%;
}

.footer-copyrights,
.footer-copyrights a,
.footer-copyrights a:hover,
.footer-copyrights a:active {
    color: #0B1547;
    font-family: Poppins;
    margin-bottom: 42px;
}

.footer-social {
    align-items: center;
    gap: 10px;
}

@media screen and (max-width: 1024px) {
    .footer {
        border-radius: 96px 96px 0px 0px;
        padding: 113px 12px 16px 16px;
    }
    .footer-banner {
        padding: 0;
    }
    .h2-headline-500-mobile {
        font-size: 30px;
    }
    .footer-end {
        flex-direction: column;
        align-items: start;
        border: none;
        padding: 0;
    }
    .footer-social {
        padding-bottom: 70px;
    }
}

.footer-mobile-language-btn {
    width: auto;
}

.footer-mobile-language-btn > .ant-select-selector {
    background: none !important;
    height: 52px !important;
}

:where(.css-dev-only-do-not-override-142vneq).footer-mobile-language-btn.ant-select-single .ant-select-selector {
    font-size: 16px;
    letter-spacing: 0.48px;
}

:where(.css-dev-only-do-not-override-142vneq).footer-mobile-language-btn.ant-select .ant-select-selection-item {
    font-weight: 500;
}

.footer-mobile-language-btn .ant-select-selection-item::after {
    content: ">";
    margin-left: 6px;
    margin-left: 6px;
    transform: rotate(90deg);
    display: inline-block;
    font-size: 16px;
}

.footer-mobile-language-btn .ant-select-focused .ant-select-open > .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
}

.footer-transfeera {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    gap: 32px;

    img.logo{
        height: 48px;
    }

    @media screen and (max-width: 576px) {
        img.logo{
            height: 36px;
        }
        
    }
}

.h3-footer-companies{
    width: 100%;
    flex: none;
    border-top: 1px solid #BFBFBF;
    padding-top: 56px;
    margin-block: 24PX;

    h2{
        font-weight: 600 !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Footer.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,qCAAqC;IACrC,eAAe;IACf,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;;;;IAII,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,gCAAgC;QAChC,6BAA6B;IACjC;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,YAAY;QACZ,UAAU;IACd;IACA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;;IAEX,SAAS;;IAET;QACI,YAAY;IAChB;;IAEA;QACI;YACI,YAAY;QAChB;;IAEJ;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;;IAElB;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".footer {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0px 160px;\n    text-align: center;\n    border-radius: 240px 250px 0px 0px;\n    background: #FFF;\n}\n\n.ant-layout-footer {\n    padding: 0px !important;\n    background: none !important;\n}\n\n.footer-banner {\n    padding-top: 200px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.footer-grid-container {\n    display: grid;\n    /* grid-template-columns: repeat(6, 1fr); */\n    grid-template-columns: repeat(7, 1fr);\n    /* gap: 42px; */\n    gap: 16px;\n    padding-top: 200px;\n}\n\n.footer-item-title {\n    letter-spacing: 0.42px;\n}\n\n.footer-item-list {\n    text-align: left;\n}\n\n.footer-submenu-list {\n    list-style: none;\n    padding: 0px;\n    margin-bottom: 12px;\n}\n\n.footer-item-submenu {\n    padding: 10px 0;\n    letter-spacing: 0.42px;\n}\n\n.mobile-footer-content {\n    width: 100%;\n    padding: 70px 0;\n}\n\n.mobile-footer-item-list {\n    text-align: left;\n}\n\n.footer-end {\n    flex-direction: row-reverse;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    margin: 56px 0;\n    border-top: 1px solid #BFBFBF;\n    padding-top: 42px;\n}\n\n.footer-banner .button-row {\n    min-width: 270px;\n    width: fit-content;\n}\n\n.footer-banner .button-row .button-yellow-md {\n    height: 160px;\n    width: 100%;\n}\n\n.footer-copyrights,\n.footer-copyrights a,\n.footer-copyrights a:hover,\n.footer-copyrights a:active {\n    color: #0B1547;\n    font-family: Poppins;\n    margin-bottom: 42px;\n}\n\n.footer-social {\n    align-items: center;\n    gap: 10px;\n}\n\n@media screen and (max-width: 1024px) {\n    .footer {\n        border-radius: 96px 96px 0px 0px;\n        padding: 113px 12px 16px 16px;\n    }\n    .footer-banner {\n        padding: 0;\n    }\n    .h2-headline-500-mobile {\n        font-size: 30px;\n    }\n    .footer-end {\n        flex-direction: column;\n        align-items: start;\n        border: none;\n        padding: 0;\n    }\n    .footer-social {\n        padding-bottom: 70px;\n    }\n}\n\n.footer-mobile-language-btn {\n    width: auto;\n}\n\n.footer-mobile-language-btn > .ant-select-selector {\n    background: none !important;\n    height: 52px !important;\n}\n\n:where(.css-dev-only-do-not-override-142vneq).footer-mobile-language-btn.ant-select-single .ant-select-selector {\n    font-size: 16px;\n    letter-spacing: 0.48px;\n}\n\n:where(.css-dev-only-do-not-override-142vneq).footer-mobile-language-btn.ant-select .ant-select-selection-item {\n    font-weight: 500;\n}\n\n.footer-mobile-language-btn .ant-select-selection-item::after {\n    content: \">\";\n    margin-left: 6px;\n    margin-left: 6px;\n    transform: rotate(90deg);\n    display: inline-block;\n    font-size: 16px;\n}\n\n.footer-mobile-language-btn .ant-select-focused .ant-select-open > .ant-select-selector {\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.footer-transfeera {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n\n    gap: 32px;\n\n    img.logo{\n        height: 48px;\n    }\n\n    @media screen and (max-width: 576px) {\n        img.logo{\n            height: 36px;\n        }\n        \n    }\n}\n\n.h3-footer-companies{\n    width: 100%;\n    flex: none;\n    border-top: 1px solid #BFBFBF;\n    padding-top: 56px;\n    margin-block: 24PX;\n\n    h2{\n        font-weight: 600 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
